const settings = {
  APP_URL: process.env.VUE_APP_URL,
  CLUB_ID: process.env.VUE_APP_CLUB_ID
}

export default settings
